<template>
  <div style="width: 1200px;margin: 0 auto;">
    <div style="text-align: center; padding-top: 30px; margin: 0 auto 40px;position: relative;width: 976px">
      <img :src="ossPath + '/pages/home/hot_compare_title.png'" alt="">
    </div>
    <div class="filter-bar">
      <div class="pod_country_select">
        <span class="label">目的国</span>
        <select-place-template4
          ref="endCountry"
          v-model="endPlace"
          :tab-head-list="continentCountryTabHeadList"
          :default-tab-value.sync="continentCountryDefaultTabValue"
          :data="continentCountryDataset"
          :is-loading="continentCountryLoading"
          filter-hot
          filter-other-tabs
          @change="changeEndPlace"
          @focus="focusOrBlur(true)"
          @blur="focusOrBlur(false)"
          popover-width="600"
          placeholder="请选择目的国家"
          class="select-place-item"
        />
        <img :src="ossPath + '/pages/home/icon_dropdown_fill.png'" alt="" class="dropdown"
             :class="{ 'is-focus': countryFocus }">
      </div>
      <div style="width: 1008px">
        <transportation-plan-bar :list="transportationPlanList" @change="planTabChange"></transportation-plan-bar>
      </div>
    </div>
    <div style="margin-top: 23px;" v-if="wcWarehouseList.length">
      <FBAWarehouseSelectNew :list="wcWarehouseList" @clickCode="clickWarehouse"></FBAWarehouseSelectNew>
      <!--<FBAWarehouseSelect :list="wcWarehouseList" :default-id="warehouseId" @handleClick="clickWarehouse"></FBAWarehouseSelect>-->
    </div>
    <div style="margin-top: 20px;position:relative;" class="priceCarousel" v-logo-loading="lableDataloading"
         element-loading-text="查询中...">
      <template v-if="lableData.length > 1">
        <div class="left-page" @click="handlePrev">
          <img :src="ossPath + '/pages/home/icon_page_left.png'" alt="">
        </div>
        <div class="right-page" @click="handleNext">
          <img :src="ossPath + '/pages/home/icon_page_right.png'" alt="">
        </div>
      </template>
      <el-carousel
        ref="priceCarousel"
        :autoplay="false"
        :height="`${carouselHeight}px`"
        arrow="never"
        @change="priceCarouselChange"
        indicator-position="none">
        <el-carousel-item v-for="(list, index) in lableData" :key="index">
          <price-item
            v-for="(item, index) in list"
            :key="index"
            :data="item"
            @toOrder="getUsertypeRap">
          </price-item>
        </el-carousel-item>
      </el-carousel>
      <div class="custom-indicator" v-if="lableData.length > 1">
        <div
          v-for="(item, index) in lableData"
          :key="index"
          @mouseenter="() => changeCarouselIndex(index)"
          class="custom-indicator-item"
          :class="{ 'custom-indicator-item-active': activeIndex === index }"></div>
      </div>
    </div>
    <!--<div style="overflow:hidden;">
      <vue-seamless-scroll :data="lableData" v-loading="lableDataloading" :class-option="optionHover" style="margin-top: 32px;overflow:hidden;" :style="scrollStyle" class="container">
      <div v-for="(item, index) in lableData" :key="index" style="margin-bottom: 8px;" :style="scrollStyle">
        <priceItem
          :data="item"
          :index="index"
          @getUsertypeRap="getUsertypeRap"
          @refreshFavoritesLineProduct="getFBAcount"
          :searchType="false"
          :loading="lableDataloading"
          :options="options">
        </priceItem>
      </div>
    </vue-seamless-scroll>
    </div>-->
    <cannot-place-order :show.sync="cannotPlaceOrderShow" :servicePicUrl="servicePicUrl"></cannot-place-order>
  </div>
</template>

<script>
import selectPlaceTemplate4 from "../../../../../common/newSelectPlace/selectPlaceTemplate4.vue";
import {debounce, isObject} from "my-tools-kit";
import {getLocalId} from "@/assets/js/utils";
import transportationPlanTab from "../transportationPlanTab.vue";
import {sortRecommendList} from "../../../../../common/priceBlurring/utils";
import {sendCustomerOperationRecord, splitPriceInfo} from "../../../../assets/js/utils";
import priceItem from "./components/priceItem.vue";
import FBAWarehouseSelect from "../FBAWarehouseSelect.vue";
import vueSeamlessScroll from 'vue-seamless-scroll'
import transportationPlanBar from "./components/transportationPlanBar.vue";
import FBAWarehouseSelectNew from "../FBAWarehouseSelectNew.vue";
import CannotPlaceOrder from "../../../../../common/cannot-place-order.vue";
import { mapGetters } from 'vuex'

export default {
  name: "homeHotPriceCompare",
  components: {
    selectPlaceTemplate4, transportationPlanTab, priceItem,
    FBAWarehouseSelect, vueSeamlessScroll, transportationPlanBar,
    FBAWarehouseSelectNew,
    CannotPlaceOrder
  },
  props: {

  },
  computed: {
    ...mapGetters(['token']),
    optionHover () {
      return {
        hoverStop: true,
        limitMoveNum: 3,
      }
    },
  },
  data() {
    const ossPath = this.ossPath;
    return {
      ossPath,
      endPlace: {},
      /* 七大洲分类国家列表 */
      continentCountryLoading:false,
      continentCountryDataset:{},//数据集
      continentCountryTabHeadList:[],
      continentCountryDefaultTabValue:"",// 目的地选择弹窗默认选中的tab
      startPlaceList: [],
      defaultCity: {},
      transportationPlanList: [],
      transportSchemeId: '',
      transportSchemeName: '',
      // 报价集合
      lableData: [],
      lableDataloading: false,
      options: {
        showComment: false,
        showLabel: false,
        showDetailPrice: false,
        showContactLine: false,
        showDetail: false,
        btnPlain: true,
        taxIncludeType: 2
      },
      wcWarehouseList: [],
      warehouseId: '',
      activeIndex: 0,
      carouselHeight: 541,
      countryFocus: false,
      // 展示不能去下单提示
      cannotPlaceOrderShow: false,
      servicePicUrl: ''
    }
  },
  methods: {
    /**
     * 根据七大洲分类获取所有国家列表
     */
    getContinentEndCountryList() {
      const data = {};
      const url = "/api/filedata/findContinentCountryList";
      this.continentCountryLoading = true;
      return this.axios.get(url, {params: data})
        .then(res => {
          res = isObject(res.data) ? res.data : {};
          if (res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res => {
          this.continentCountryLoading = false;
          let list = res.datas || [];
          let {defaultValue,tabHeadList,dataset} = this.createContinentEndCountryTabHeadList(list);
          // console.log('1==============',defaultValue,tabHeadList,dataset)
          this.continentCountryDefaultTabValue = defaultValue;
          this.continentCountryTabHeadList = tabHeadList;
          this.continentCountryDataset = dataset;
          return res
        })
        .catch(res => {
          this.continentCountryLoading = false;
          this.continentCountryDefaultTabValue = "";
          this.continentCountryTabHeadList = [];
          this.continentCountryDataset = {};
          // return Promise.reject(res);
        })
    },
    createContinentEndCountryTabHeadList(topList=[]){
      topList = this.continentListSort(topList, 'continentNameCn')
      let tabHeadList =  [];
      let defaultValue = "";
      let dataset = {};
      topList.forEach((item,index)=>{
        let id = `${item.continentId||""}`;
        if(!id) id = getLocalId();
        let namec = item.continentNameCn||"";
        let childList = item.countryInfoList||[];
        childList.forEach(twoItem=>{
          twoItem.continentNameCn = item.continentNameCn||"";
          twoItem.continentNameEn = item.continentNameEn||"";
          twoItem.privateAddressType = twoItem.privateAddressType || 1;
        })
        if(index === 0 ) defaultValue = id;
        let code = `${item.code||""}`;
        let opt = {
          label: namec,
          value: id,// tab自身标识
          listLevel:1,// 列表的层级，只支持1和2
          showLeftLabel:false,// 2级列表是否显示左边的分组标签（展示首字母开头）
          openSelectAll:false,// 是否展示全选按钮
        };
        if(!dataset[id]) {
          dataset[id] = childList;
          tabHeadList.push(opt);
        }
      })
      return {
        defaultValue,
        tabHeadList,
        dataset,
      }
    },
    /**
     * 大洲排序并删除南极洲
     * @param list
     * @param key
     */
    continentListSort(list = [], key = 'continentName') {
      const sortedContinent = ['全部', '亚洲', '欧洲', '非洲', '北美洲', '南美洲', '大洋洲']
      list = list.filter(continentItem => continentItem[key] !== '南极洲')
      list = list.sort((a, b) => {
        const index1 = sortedContinent.findIndex(item => a[key] === item)
        const index2 = sortedContinent.findIndex(item => b[key] === item)
        return index1 - index2
      })
      return list
    },
    async changeEndPlace(data = {}) {
      this.wcWarehouseList = []
      this.warehouseId = ''
      this.endPlace = data
      await this.getTransportScheme()
      this.getFBAcount()
      sendCustomerOperationRecord('热门比价', `国家:${data.namec}`)
    },
    /**
     * 获取起运地列表
     */
    getStartPlaceList(){
      const data = {
        // 起运城市类型，null：全部（包含直拼和转运），1：直拼， 2：转运
        // cityType:this.transferType,
        cityType:"",
      };
      const url = "/api/filedata/findAllFromCity";
      return this.axios.post(url, data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          let list = res.datas||[];
          list = list.map(res=>{
            if(!isObject(res)) return undefined;
            return {
              code:res.code||"",
              list:res.fromCityDTOList||[],
            }
          });
          this.startPlaceList = list;
          return res
        })
        .catch(res=>{
          this.startPlaceList = [];
          // return Promise.reject(res);
        })
    },
    /**
     * 获取运输方案列表
     * @param defaultId {string|number} 默认选中id
     * @return {Promise<AxiosResponse<unknown>>}
     */
    async getTransportScheme(defaultId='') {
      const params = {
        customerId: this.sessionGetUserInfo().customerid,
        pollandId: this.defaultCity.id,
        podlandId: '',
        toCountryId: this.endPlace.id,
        zipcodeFirst: '',
        cityType: '',
        transportCodes: ['ALL'],
        keyword: '',
        goodstypeId: '',
        deliveryType: ''
      }
      const res = await  this.axios.post('/FBAfee/queryHotComparisonByTransportScheme', params)
      if (res.data.code === 200) {
        this.transportationPlanList = res.data.datas || []
        if (this.transportationPlanList.length) {
          let index;
          if(defaultId || defaultId===0) {
            index = this.transportationPlanList.findIndex(item=>item.id===defaultId)
          }
          if(index >= 0){
            let item = this.transportationPlanList[index];
            this.transportSchemeId = defaultId;
            this.transportSchemeName = item.transportSchemeName;
          } else {
            this.transportSchemeId = this.transportationPlanList[0].id
            this.transportSchemeName = this.transportationPlanList[0].transportSchemeName
          }
        } else {
          this.transportSchemeName = '';
        }
      }
      return res
    },
    planTabChange(item) {
      this.transportSchemeId = item.id;
      this.transportSchemeName = item.transportSchemeName;
      if (this.transportSchemeName.includes('整柜直送')) {
        this.getWcWarehouseList()
      } else {
        this.wcWarehouseList = []
        this.warehouseId = ''
      }
      this.getFBAcount()
      sendCustomerOperationRecord('热门比价', `运输方案名称:${item.transportSchemeName}`)
    },
    getFBAcount:debounce(function(Type) {
      // FBA查询报价

      const params = {
        customerId: this.sessionGetUserInfo().customerid,
        pollandId: this.defaultCity.id,
        podlandId: this.warehouseId,
        toCountryId: this.endPlace.id,
        zipcodeFirst: '',
        cityType: '',
        transportCodes: ['ALL'],
        keyword: '',
        goodstypeId: '',
        deliveryType: '',
        transportSchemeId: this.transportSchemeId,
      };
      if (this.endPlaceType !== 0) {
        params.podlandType = this.endPlaceType
      }
      // if (this.warehouseTypeCurrent === 'private' && this.privateAddressType == 3)  params.podlandId = this.toStoreid.substring(0,1)
      if (!params.podlandId) delete params.podlandId // 目的地为全部时不传podlandId
      this.lableDataloading = true
      this.axios
        .post("/FBAfee/queryHotComparisonByPrice", params)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then((res) => {
          let list = res.datas || [];
          if(this.$store.getters.realNameState !== 3) sortRecommendList(list);
          if(list.length <= 0){
            this.lableData = [];
            this.supplementaryPageType = true
            this.showTive = true;
          }
          // 两个主推产品排序
          // const sortIds = [19005670200,19010985000];//id越靠后，排在越前面
          // sortIds.forEach(id=>{
          //   let index = list.findIndex(item=>item.productId === id);
          //   if(index<=0) return false;
          //   let item = list[index];
          //   list.splice(index,1);
          //   list.unshift(item);
          // })
          list.forEach(item => {
            if(item.priceinfo){
              let priceInfo = splitPriceInfo(item.priceinfo);
              item.price = priceInfo.price;
              item.unit = priceInfo.unit;
            }
            item.cityName = item.cityList.map(item_1 => item_1.cityName).join(',')
            item.goodsTypeName = item.goodsTypeList.map(item_2 => item_2.goodsTypeName).join(',')
          })
          this.lableData = this.chunkArray(list, 5);
          if (this.lableData.length) {
            this.carouselHeight = this.lableData[0].length * 90
          } else {
            this.carouselHeight = 0
          }
          this.removeAutoScroll()
          if (list.length > 3) {
            this.$nextTick(() => {
              this.startScroll()
            })
          }
          this.lableDataloading = false
        })
        .catch((res) => {
          console.log(res)
          this.lableDataloading = false;
          this.lableData = [];
          this.$message.error(res.message||"请求网络超时，请稍后再试！");
        });
    },200,false),
    getUsertypeRap(item, store) {
      console.log("去下单？？?？");
      if (!this.token) {
        this.$root.Bus.$emit("showDialog", 0, true);
        return
      }
      this.servicePicUrl = item.wxUrl
      this.cannotPlaceOrderShow = true
      return
      if (store) {
        console.log('1');
        sessionStorage.setItem("toFABck", JSON.stringify(store));
      }
      if (this.endPoi) {
        console.log('2');

        sessionStorage.setItem("toFABck", JSON.stringify(this.endPoi))
      }
      if (!this.sessionGetUserInfo().token) {
        console.log('3');

        this.$root.Bus.$emit("showDialog", 0, true);
      } else {
        console.log('4');

        sendCustomerOperationRecord("去下单",`产品名称:${item.productName}`, { productId: item.productId })
        let customerId = this.sessionGetUserInfo().customerid;
        this.axios
          .get(`/corporation/checkCustomerIsAvailable/${customerId}`)
          .then((res) => {
            if (res.data.code == 200) {
              this.handleNewClick(item);
            } else {
              return this.$message({
                message: "该账号暂未通过审核，请联系客服人员",
                type: "warning",
                offset: "500",
              });
            }
          })
          .catch((res) => {});
      }
    },
    handleNewClick(item) {
      //去下单
      let tuoCheDataChecked = false;
      sessionStorage.setItem("goodsTypeName", JSON.stringify(item.goodstype));
      sessionStorage.setItem("itemWrap", JSON.stringify(item));
      sessionStorage.setItem("transportTypeCode",item.transportTypeCode);
      sessionStorage.removeItem("countLIst_T");
      sessionStorage.setItem("fromCityid", item.fromCityId)
      const routerData = this.$router.resolve({
        path: "/takeOrder",
        query: {
          THFtype: tuoCheDataChecked,
          transportTypeCode: item.transportTypeCode,
          productPriceHeaderId: item.productPriceHeaderId,
          supplierId: item.carrierId ? item.carrierId : '',
          toCountryid: this.endPlace.id,
          itemWrap: item,
          goodsTypeNames: item.goodsTypeNames,
          queryRow: JSON.stringify({
            pollandId: this.defaultCity.id,
            podlandId: '',
            goodstypeId: 0,
            transportCodes: ['ALL'],
            toCountryId: this.endPlace.id,
          })
        },
      });
      window.open(routerData.href, '_blank')
    },
    // 获取整柜直送派送方案下所有的仓库
    getWcWarehouseList() {
      const data = {
        pollandId: this.defaultCity.id,
        podlandId: '',
        toCountryId: this.endPlace.id,
        zipcodeFirst: '',
        cityType: '',
        transportCodes: ['ALL'],
        keyword: '',
        goodstypeId: 0,
        deliveryType: '',
        transportSchemeId: this.transportSchemeId,
        containsTheTariffs: null,
        isShareWarehouseLine: false,
        customerId: this.sessionGetUserInfo().customerid,
      }
      this.axios.post('/api/FBAfee/warehouseCodeList', data)
        .then(res => {
          if (res.data.code === 200) {
            this.wcWarehouseList = res.data.data.datWarehouseDTOList || []
            this.warehouseId = this.wcWarehouseList.length ? this.wcWarehouseList[0].id : ''
          }
        })
    },
    clickWarehouse(item) {
      console.log(item)
      this.warehouseId = item.id
      this.getFBAcount()
    },
    startScroll() {
      const content = document.querySelector('.content');
      if (!content) return
      content.classList.add('scrolling');
      content.classList.remove('paused');
    },
    stopScroll() {
      const content = document.querySelector('.content')
      if (!content) return
      content.classList.add('paused');
    },
    removeAutoScroll() {
      const content = document.querySelector('.content');
      if (!content) return
      content.classList.remove('scrolling');
    },
    scrollStyle() {
      const priceLength = this.lableData.length
      const wcWarehouseLength = this.wcWarehouseList.length
      let height = 0
      if (wcWarehouseLength) height = 40
      if (priceLength <= 3) {
        height += 125 * priceLength.height
      } else {
        height += 375
      }
      return `height: ${height}px`
    },
    /**
     * @description 将原数组转化为以chunkSize为大小的二维数组
     * @param arr {array}
     * @param chunkSize {number}
     * @returns {*[]}
     */
    chunkArray(arr, chunkSize) {
      const chunkedArray = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        chunkedArray.push(arr.slice(i, i + chunkSize));
      }
      return chunkedArray;
    },
    handlePrev() {
      this.$refs.priceCarousel.prev()
    },
    handleNext() {
      this.$refs.priceCarousel.next()
    },
    priceCarouselChange(index) {
      this.activeIndex = index
    },
    changeCarouselIndex(index) {
      this.$refs.priceCarousel.setActiveItem(index)
    },
    focusOrBlur(isFocus) {
      this.countryFocus = isFocus
    }
  },
  created() {
    const p1 = this.getContinentEndCountryList().then(res => {
      const list = res.datas
      let countryList = []
      list.forEach(item => {
        countryList.push(...item.countryInfoList)
      })
      this.endPlace = countryList.find(item => item.code === 'US')
      console.log('p1settled')
    })
    const p2 = this.getStartPlaceList().then(res => {
      const list = res.datas || []
      let cityList = []
      list.forEach(item => {
        cityList.push(...item.fromCityDTOList)
      })
      this.defaultCity = cityList.find(item => item.namec === '深圳')
    })
    Promise.all([p1, p2]).then(async () => {
      await this.getTransportScheme()
      this.getFBAcount()
    })
  },
  mounted() {
    const container = document.querySelector('.container');
    container.addEventListener('mouseenter', this.stopScroll);
    container.addEventListener('mouseleave', this.startScroll);
  }
}
</script>

<style lang="less" scoped>
.search-bottom-box {
  margin-top: -220px;
  position: relative;
  padding-top: 230px;
  padding-bottom: 40px;
  // background: #fff;
  z-index: 0;
  // overflow: hidden;
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: top center;
  .city-bg {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
  .Hotwrap {
    margin-top: 0;
    // position: relative;
  }
  // background: #fff;
}
.filter-bar {
  display: flex;
}
.pod_country_select {
  width: 179px;
  height: 60px;
  margin-right: 13px;
  background: #FFFFFF;
  border-radius: 8px;
  display: flex;
  align-items: center;
  font-size: 16px;
  position: relative;
  .label {
    margin-left: 8px;
    margin-right: 10px;
    color: #999999;
  }
  .select-place-item {
    width: 100px;
    height: 38px;
    box-shadow: 0 0 4px 0 rgba(0,0,0,0.1);
    border-radius: 4px;
    border: 1px solid #DDDDDD;
    line-height: 30px;
    font-size: 14px;
    background: transparent;
    /deep/ .el-input__inner {
      padding: 0 0 0 10px;
      font-size: 16px;
      color: #141414;
      line-height: 38px;
    }
  }
  .dropdown {
    position: absolute;
    right: 21px;
    bottom: 24px;
    transform: rotate(0);
    transition: all .3s ease;
  }
  .is-focus {
    transform: rotate(180deg);
  }
}
.scheme {
  /deep/ #arrow {
    background: #FAFAFA;
  }
}
.container {
  //overflow: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
}
.content {
  /* 宽度和内容高度可以根据需要调整 */
  width: 100%;
  height: 100%;
}
.scrolling {
  animation: scroll 10s linear infinite;
  animation-delay: 1s;
}

.paused {
  animation-play-state: paused; /* 暂停滚动动画 */
}

@keyframes scroll {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100%);
  }
}

.left-page {
  position: absolute;
  left: -40px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.right-page {
  position: absolute;
  right: -40px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}

.priceCarousel {
  /deep/ .el-carousel__indicators--horizontal {
    position: absolute;
    bottom: 0;
    .el-carousel__indicator--horizontal {

    }
  }
  /deep/ .el-carousel__indicator{
    .el-carousel__button {
      width: 40px;
      height: 6px;
      background: #D8D8D8;
    }
    &.is-active{
      .el-carousel__button{
        background: #FF4D01 !important;
      }
    }
  }
  .custom-indicator {
    width: 100%;
    margin: 37px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
    cursor: pointer;
    &-item {
      width: 40px;
      height: 6px;
      margin-right: 20px;
      background: #D8D8D8;
      &-active {
        background: #FF4D01;
      }
      &:hover {
        background: #FF4D01;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/homeHotPriceCompare/index.vue